import moment from 'moment';
import { ILocation, IProject } from '../entities';

export const feedTitle = (project: IProject, mappedLocations: Record<number, ILocation>) =>
  [moment(project.date).format('dddd MMM, D'), project.name, mappedLocations[project.locationId!]?.normalizedName]
    .filter((cur) => !!cur)
    .join(', ');
